import { setCartItems } from 'dibs-buyer-layout/src/actions/cartActions';
import { actionCreators } from 'dibs-buyer-layout/src/actions/';

const { setUserTypeTrade, toggleMobileMenu } = actionCreators;

export { setCartItems, setUserTypeTrade, toggleMobileMenu };
